// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UAMachineryLifetimeVariable } from './UAMachineryLifetimeVariable';
import {
    UAMachineryLifetimeVariableFromJSON,
    UAMachineryLifetimeVariableFromJSONTyped,
    UAMachineryLifetimeVariableToJSON,
    UAMachineryLifetimeVariableToJSONTyped,
} from './UAMachineryLifetimeVariable';
import type { UAAlarmCondition } from './UAAlarmCondition';
import {
    UAAlarmConditionFromJSON,
    UAAlarmConditionFromJSONTyped,
    UAAlarmConditionToJSON,
    UAAlarmConditionToJSONTyped,
} from './UAAlarmCondition';
import type { UAMachineryOperationCounter } from './UAMachineryOperationCounter';
import {
    UAMachineryOperationCounterFromJSON,
    UAMachineryOperationCounterFromJSONTyped,
    UAMachineryOperationCounterToJSON,
    UAMachineryOperationCounterToJSONTyped,
} from './UAMachineryOperationCounter';
import type { UADIDeviceHealthEnumeration } from './UADIDeviceHealthEnumeration';
import {
    UADIDeviceHealthEnumerationFromJSON,
    UADIDeviceHealthEnumerationFromJSONTyped,
    UADIDeviceHealthEnumerationToJSON,
    UADIDeviceHealthEnumerationToJSONTyped,
} from './UADIDeviceHealthEnumeration';
import type { UALADSComponentIdentification } from './UALADSComponentIdentification';
import {
    UALADSComponentIdentificationFromJSON,
    UALADSComponentIdentificationFromJSONTyped,
    UALADSComponentIdentificationToJSON,
    UALADSComponentIdentificationToJSONTyped,
} from './UALADSComponentIdentification';

/**
 * 
 * @export
 * @interface UALADSComponent
 */
export interface UALADSComponent {
    /**
     * 
     */
    browseName: string;
    /**
     * 
     */
    displayName: string;
    /**
     * AssetId is a user writable alphanumeric character sequence uniquely identifying a component. The ID is provided by the integrator or user of thedevice.
     */
    assetId?: string;
    /**
     * ComponentName is a user writable name provided by the integrator or user of the component.
     */
    componentName?: string;
    /**
     * HierarchicalLocation provides the hierarchical
     * location of the LADS Device. The structure inside
     * the string may expose several levels. How this is
     * exposed, which delimiters are used, etc. is
     * vendor-specific. Examples of such strings are
     * “FactoryA/BuildingC/Floor1” or
     * “Area1-ProcessCell17-Unit4” (see OPC UA OPC
     * 10000-110 for more Details).
     */
    hierarchicalLocation?: string;
    /**
     * OperationalLocation provides the operational
     * location of the Device or Component. The
     * structure within the string may expose several
     * levels. How this is exposed, which delimiters are
     * used, etc. is vendor-specific. Examples of such
     * strings are “Warehouse1/Sheet3” or
     * “StainlessSteelTote3” (see OPC UA OPC 10000-110
     * for more details).
     */
    operationalLocation?: string;
    /**
     * 
     */
    identification: UALADSComponentIdentification;
    /**
     * 
     */
    deviceHealth?: UADIDeviceHealthEnumeration;
    /**
     * 
     */
    deviceHealthAlarms?: Array<UAAlarmCondition>;
    /**
     * 
     */
    lifetimeCounters?: Array<UAMachineryLifetimeVariable>;
    /**
     * 
     */
    operationCounters?: Array<UAMachineryOperationCounter>;
    /**
     * 
     */
    maintenance?: Array<object>;
    /**
     * 
     */
    components?: Array<UALADSComponent>;
}



/**
 * Check if a given object implements the UALADSComponent interface.
 */
export function instanceOfUALADSComponent(value: object): value is UALADSComponent {
    if (!('browseName' in value) || value['browseName'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('identification' in value) || value['identification'] === undefined) return false;
    return true;
}

export function UALADSComponentFromJSON(json: any): UALADSComponent {
    return UALADSComponentFromJSONTyped(json, false);
}

export function UALADSComponentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UALADSComponent {
    if (json == null) {
        return json;
    }
    return {
        
        'browseName': json['browseName'],
        'displayName': json['displayName'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'componentName': json['componentName'] == null ? undefined : json['componentName'],
        'hierarchicalLocation': json['hierarchicalLocation'] == null ? undefined : json['hierarchicalLocation'],
        'operationalLocation': json['operationalLocation'] == null ? undefined : json['operationalLocation'],
        'identification': UALADSComponentIdentificationFromJSON(json['identification']),
        'deviceHealth': json['deviceHealth'] == null ? undefined : UADIDeviceHealthEnumerationFromJSON(json['deviceHealth']),
        'deviceHealthAlarms': json['deviceHealthAlarms'] == null ? undefined : ((json['deviceHealthAlarms'] as Array<any>).map(UAAlarmConditionFromJSON)),
        'lifetimeCounters': json['lifetimeCounters'] == null ? undefined : ((json['lifetimeCounters'] as Array<any>).map(UAMachineryLifetimeVariableFromJSON)),
        'operationCounters': json['operationCounters'] == null ? undefined : ((json['operationCounters'] as Array<any>).map(UAMachineryOperationCounterFromJSON)),
        'maintenance': json['maintenance'] == null ? undefined : json['maintenance'],
        'components': json['components'] == null ? undefined : ((json['components'] as Array<any>).map(UALADSComponentFromJSON)),
    };
}

export function UALADSComponentToJSON(json: any): UALADSComponent {
    return UALADSComponentToJSONTyped(json, false);
}

export function UALADSComponentToJSONTyped(value?: UALADSComponent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browseName': value['browseName'],
        'displayName': value['displayName'],
        'assetId': value['assetId'],
        'componentName': value['componentName'],
        'hierarchicalLocation': value['hierarchicalLocation'],
        'operationalLocation': value['operationalLocation'],
        'identification': UALADSComponentIdentificationToJSON(value['identification']),
        'deviceHealth': UADIDeviceHealthEnumerationToJSON(value['deviceHealth']),
        'deviceHealthAlarms': value['deviceHealthAlarms'] == null ? undefined : ((value['deviceHealthAlarms'] as Array<any>).map(UAAlarmConditionToJSON)),
        'lifetimeCounters': value['lifetimeCounters'] == null ? undefined : ((value['lifetimeCounters'] as Array<any>).map(UAMachineryLifetimeVariableToJSON)),
        'operationCounters': value['operationCounters'] == null ? undefined : ((value['operationCounters'] as Array<any>).map(UAMachineryOperationCounterToJSON)),
        'maintenance': value['maintenance'],
        'components': value['components'] == null ? undefined : ((value['components'] as Array<any>).map(UALADSComponentToJSON)),
    };
}

